import React from "react";
import { urlFor } from "../client";

const SingleSeminar = ({ singleSeminar }) => {
  return (
    <div id="singleSeminar">
      <div className="publish">
        <small>
          By <span>Laser Treat</span> at <span>{singleSeminar.location}</span>{" "}
          on <span>{singleSeminar.dop}</span>
        </small>
      </div>
      <img
        src={singleSeminar.seminarimg && urlFor(singleSeminar.seminarimg)}
        alt=""
        className="bigBanner"
      />

      <div className="title">
        <h1>{singleSeminar.title}</h1>
      </div>

      <p className="det">{singleSeminar.fulldesc}</p>

      <div className="realted-photos">
        <h2>Related Photos</h2>
        <div className="gallery">
          <img
            src={singleSeminar.otherimg1 && urlFor(singleSeminar.otherimg1)}
            alt=""
            className="gal"
          />
          <img
            src={singleSeminar.otherimg2 && urlFor(singleSeminar.otherimg2)}
            alt=""
            className="gal"
          />
          <img
            src={singleSeminar.otherimg3 && urlFor(singleSeminar.otherimg3)}
            alt=""
            className="gal"
          />
        </div>
      </div>
    </div>
  );
};

export default SingleSeminar;
